import { render, staticRenderFns } from "./ExternalDataObjectMenu.vue?vue&type=template&id=0e57e562&"
import script from "./ExternalDataObjectMenu.vue?vue&type=script&lang=ts&"
export * from "./ExternalDataObjectMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ExternalDataObjectMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports